<template>
    <div
        v-if="(basicInfo.permission && basicInfo.privacy && basicInfo.version_name) &&
            (basicInfo.dev || basicInfo.publisher) && downloadInfo.download_url"
        class="app-download-sticky"
        :class="{'is-suspend': downloadBtnSuspend && needBottom}"
    >
        <div
            v-if="isNewStyle === 1"
            class="game-btn common-style pb-show-display flex-width"
            :data-pblog="pblogData"
            @click="download"
        >
            {{ downloadInfo.download_button_name ? downloadInfo.download_button_name : '安全下载' }}
        </div>
        <div
            v-else
            class="game-btn common-style pb-show-display flex-width"
            :data-pblog="pblogData"
            @click="download"
        >
            {{ isDownload ? '下载' : '进入' }}
        </div>
    </div>
</template>

<script>
import {throttle} from 'throttle-debounce';
import {getQueryString} from '@/utils/url';
import {browserDetect, isIOS, downloadApk} from '@/utils/browser';
import {on} from '@/utils/dom';
import bus from '../bus/bus';
import ligthingIcon from 'public/assets/imgs/lighting_icon.png';
import {openPage} from '@/utils/utility';
let firstClick = true;

export default {
    props: {
        basicInfo: {
            type: Object,
            required: true,
        },
        downloadInfo: {
            type: Object,
            required: true,
        },
        needBottom: {
            type: Boolean,
            default: false,
        },
        position: {
            type: String,
            default: 'inPage',
        },
        isNewStyle: {
            type: Number,
            detail: 0,
        },
    },
    data() {
        return {
            downloadBtnSuspend: false,
            isIOS: isIOS(),
            channelid: getQueryString('channelid'),
            pblogData: {},
            ligthingIcon,
            appPblogData: {},
        };
    },
    computed: {
        isDownload() {
            return !this.isIOS || (this.isIOS && this.downloadInfo.ios_url);
        },
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                on(window, 'scroll', throttle(200, this.suspendLangBtn));
            }, 200);
        });
        const {app_name, app_id, app_type} = this.downloadInfo;
        this.pblogData = JSON.stringify({
            value: 'downloadNormal',
            ext: {
                item: [
                    {
                        id: '',
                        ext: {
                            gameName: app_name,
                            srcId: getQueryString('srcid') || '',
                            sid: getQueryString('sid'),
                            channelid: getQueryString('channelid') || '',
                            gameId: app_id,
                            gameType: app_type,
                            clickType: 'gameBtn',
                            clickBtnType: 'download',
                            clickBtnPos: this.position,
                            moduleName: '普通下载',
                            posType: 'highSpeedPos',
                            pageType: 'AldDetailPageH5',
                        },
                        pos: '',
                    },
                ],
            },
        });
        this.appPblogData = JSON.stringify({
            value: 'downloadHighSpeed',
            ext: {
                item: [
                    {
                        id: '',
                        ext: Object.assign({}, this.$root.extData || {}, {
                            moduleName: '高速下载',
                            posType: 'highSpeedPos',
                            pageType: 'AldDetailPageH5',
                        }),
                        pos: '',
                    },
                ],
            },
        });
    },
    methods: {
        suspendLangBtn() {
            const langBtnContainer = document.getElementById('gp_show_head');
            const {bottom} = langBtnContainer.getBoundingClientRect();
            if (bottom < 10) {
                this.downloadBtnSuspend = true;
            }
            else {
                this.downloadBtnSuspend = false;
            }
        },
        download() {
            if (!this.isIOS) {
                this.$emit('showDownloadDawer', true);
            }
            const {logo, package_name, download_url, ios_url, app_name, app_id, app_type, zone_appid}
                = this.downloadInfo;
            this.$logger.click({
                value: 'downloadNormal',
                ext: {
                    id: package_name,
                    ext: {
                        gameName: app_name,
                        srcId: getQueryString('srcid') || '',
                        sid: getQueryString('sid') || '',
                        channelid: getQueryString('channelid') || '',
                        gameId: app_id,
                        gameType: app_type,
                        clickType: 'gameBtn',
                        clickBtnType: 'download',
                        clickBtnPos: this.position,
                        moduleName: '普通下载',
                        posType: 'highSpeedPos',
                        pageType: 'AldDetailPageH5',
                        btnStatus: '下载',
                        isNewStyle: this.isNewStyle,
                    },
                    pos: '',
                },
                network: this.$wifi ? 'wifi' : '4g',
            });
            this.down_count = '1';
            if (firstClick && browserDetect('weixin')) {
                firstClick = false;
                bus.$emit('showGuideLayer', true);
            }
            else if (!this.isIOS) {
                downloadApk(download_url, logo, package_name, 'cb');
            }
            else if (ios_url) {
                location.href = ios_url;
            }
            else {
                const param = {
                    appId: zone_appid,
                    channelid: this.channelid,
                    query: app_name,
                    sid: '#',
                };
                openPage('zone', param);
                // location.href = `http://gamecenter.baidu.com/static/game/zone.html?appId=${zone_appid}&channelid=${this.channelid}&query=${app_name}&sid=#`;
            }
        },
    },
};
</script>

<style scoped lang="scss">
    @import "~@/common/style/mixin/utils";
    @import "~@/common/style/mixin/mixins";
    @import "~@/common/style/mixin/border";
    $design-width: 1242;
    .app-download-sticky{
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: px2rem(192);
        background: #fff;
        padding: 0 px2rem(51);
        .common-style{
            display: flex;
            align-items: center;
            justify-content: center;
            height: px2rem(132);
            border-radius: px2rem(132);
            font-size: px2rem(54);
        }
        .game-btn{
            position: relative;
            z-index: 2;
            width: px2rem(545);
            border: px2rem(3) solid #3388FF;
            color: #3388FF;
        }
        .flex-width{
            width: 100%;
            background: #3388FF;
            color: #fff;
            border: none;
        }
        .app-btn{
            position: relative;
            width: px2rem(545);
            background: #3388FF;
            color: #fff;
            .up-speed{
                position: absolute;
                right: 0;
                top: px2rem(-26);
                display:flex;
                align-items: center;
                justify-content: center;
                margin-left: px2rem(15);
                width: px2rem(211);
                height: px2rem(53);
                border-radius: px2rem(27);
                background-image:linear-gradient(-45deg, #FFE9B8 0%, #F4CC95 100%);
                box-sizing: border-box;
                .icon{
                    width: px2rem(29);
                    height: px2rem(29);
                }
                .txt{
                    font-size: px2rem(33);
                    color: #333;
                    font-weight: 500;
                }
            }
        }
    }
    .is-suspend{
        position: fixed;
        bottom: 0;
        left: 0;
        right:0;
        z-index: 30;
    }

</style>